import React from 'react';
import {
  Cloud, CloudRain, CloudSnow, Snowflake, Sun, type LucideIcon,
} from 'lucide-react';
import { WeatherType } from '@/types';
import { cn } from '@/util/cn';

const ICON_BY_TYPE: Record<WeatherType, LucideIcon> = {
  PARTLY_CLOUDY: Cloud,
  SLIGHTLY_CLOUDY: Cloud,
  SLEET_SHOWERS: CloudRain,
  RAIN_SHOWERS: CloudRain,
  OVERCAS: Cloud,
  CLOUDY: Cloud,
  FOG: Cloud,
  RAIN: CloudRain,
  LIGHT_RAI: CloudRain,
  SLEET: CloudRain,
  SNOW: Snowflake,
  SNOW_SHOWERS: CloudSnow,
  FAIR: Sun,
  SUN: Sun,
  SUNNY: Sun,
  MOSTLY_SUNNY: Sun,
  LUNE: Cloud,
  THUNDERSTORM: CloudRain,
};

const SUN_TYPES = new Set<WeatherType>(['SUN', 'SUNNY', 'FAIR', 'MOSTLY_SUNNY']);
const SNOW_TYPES = new Set<WeatherType>(['SNOW', 'SNOW_SHOWERS', 'SLEET', 'SLEET_SHOWERS']);
const RAIN_TYPES = new Set<WeatherType>(['RAIN', 'RAIN_SHOWERS', 'LIGHT_RAI']);

export const ConditionIcon = ({ type, className }: { type?: WeatherType; className?: string }) => {
  const Icon = (type && ICON_BY_TYPE[type]) || Cloud;
  const isSun = !!type && SUN_TYPES.has(type);
  const isSnow = !!type && SNOW_TYPES.has(type);
  const isRain = !!type && RAIN_TYPES.has(type);
  return (
    <Icon
      size={22}
      className={cn(
        'shrink-0',
        isSun && 'text-amber-400',
        isSnow && 'text-sky-500',
        isRain && 'text-sky-600',
        !isSun && !isSnow && !isRain && 'text-muted-foreground',
        className,
      )}
    />
  );
};
